/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ITotalSupply, ITotalSupplyInterface } from "../ITotalSupply";

const _abi = [
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ITotalSupply__factory {
  static readonly abi = _abi;
  static createInterface(): ITotalSupplyInterface {
    return new utils.Interface(_abi) as ITotalSupplyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITotalSupply {
    return new Contract(address, _abi, signerOrProvider) as ITotalSupply;
  }
}
